import React, { useState, useEffect } from 'react';

const PET_TYPE_ICON = { Dog: '🐕', Cat: '🐈', Exotic: '🐾' };

const PriorPetsDisplay = ({ phoneNumber, email, currentPetId }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!phoneNumber && !email) { setLoading(false); return; }

    const params = new URLSearchParams();
    if (phoneNumber) params.append('phone', phoneNumber);
    if (email)       params.append('email', email);
    if (currentPetId) params.append('exclude_id', currentPetId);

    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/customers/history?${params}`)
      .then(r => r.json())
      .then(d => { setData(d); setLoading(false); })
      .catch(() => setLoading(false));
  }, [phoneNumber, email, currentPetId]);

  if (loading || !data?.is_returning_client) return null;

  const { pets, total, match_type } = data;

  const matchLabel = {
    phone_and_email: '📱 + ✉️ phone & email match',
    phone:           '📱 phone match',
    email:           '✉️ email match',
  }[match_type] || '';

  return (
    <div className="mt-4 pt-4 border-t border-blue-100">
      <div className="flex items-center justify-between mb-2">
        <p className="text-sm font-semibold text-blue-800">
          🔄 Returning Client — {total} prior pet{total !== 1 ? 's' : ''}
        </p>
      </div>
      <div className="space-y-1.5">
        {pets.map(pet => {
          const icon = PET_TYPE_ICON[pet.pet_type] || '🐾';
          const date = pet.arrival_date
            ? new Date(pet.arrival_date).toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' })
            : '—';
          const done = pet.review_sms === true;
          return (
            <div key={pet.id}
              onClick={() => window.location.href = `/pets/${pet.id}`}
              className="flex items-center justify-between bg-blue-50 border border-blue-100 px-3 py-1.5 rounded-lg text-sm cursor-pointer hover:bg-blue-100 transition-colors">
              <span className="font-medium text-blue-900">
                {icon} {pet.pet_name}
                {pet.breed && <span className="text-blue-500 font-normal ml-1 text-xs">({pet.breed})</span>}
                {pet.tree_planting_option && <span className="text-green-600 font-normal ml-1 text-xs">🌳{pet.tree_planting_option}</span>}
              </span>
              <div className="flex items-center gap-2 text-xs text-gray-500">
                <span>{date}</span>
                <span className={`px-1.5 py-0.5 rounded-full font-medium ${done ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}`}>
                  {done ? '✅ Complete' : '⚙️ Active'}
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PriorPetsDisplay;
